async function fetchCart() {
  const res = await fetch('/cart.js', { credentials: 'same-origin' });
  if (!res.ok) return null;
  return res.json();
}

function pickBaseProductId(cart) {
  if (!cart?.items?.length) return null;
  const last = cart.items[cart.items.length - 1];
  return last?.product_id || cart.items[0]?.product_id || null;
}

async function renderCartDrawerUpsell() {
  const mount = document.getElementById('CartDrawer-Upsell');
  if (!mount) return;

  const cart = await fetchCart();
  const productId = pickBaseProductId(cart);

  if (!productId) {
    mount.innerHTML = '';
    return;
  }

const url =
  `/recommendations/products?snippet=cart-upsell` +
  `&product_id=${productId}` +
  `&intent=complementary`;

  const recRes = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
  if (!recRes.ok) {
    mount.innerHTML = '';
    return;
  }

  mount.innerHTML = await recRes.text();
}

async function addVariant(variantId) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ id: Number(variantId), quantity: 1 })
  });

  if (!res.ok) return;

  // Motion: bygg om drawern efter add
  document.dispatchEvent(new CustomEvent('cart:build'));
}

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-upsell-add]');
  if (!btn) return;
  e.preventDefault();
  addVariant(btn.dataset.variantId);
});

document.addEventListener('DOMContentLoaded', renderCartDrawerUpsell);

// Motion/Archetype events
document.addEventListener('cart:updated', renderCartDrawerUpsell);
document.addEventListener('ajaxProduct:added', renderCartDrawerUpsell);
